

export default () => {
  // The function actually applying the offset

  if(typeof window !== 'undefined') {
    function offsetAnchor() {
      if(location.hash.length !== 0) {
          window.scrollTo(window.scrollX, window.scrollY - 100);
      }
    }

    // This will capture hash changes while on the page
    window.addEventListener("hashchange", offsetAnchor);

    // This is here so that when you enter the page with a hash,
    // it can provide the offset in that case too. Having a timeout
    // seems necessary to allow the browser to jump to the anchor first.
    window.setTimeout(offsetAnchor, 1);
  }
}


// WEBPACK FOOTER //
// ./src/scripts/anchor-link-jump.js